// extracted by mini-css-extract-plugin
export default {"headerCart":"HeaderCart_headerCart__djNsR","mobile":"HeaderCart_mobile__Hnba7","backArrow":"HeaderCart_backArrow__OnBjj"};